(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lnr-fitting-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const recent = new WeakMap();
    try {
      if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
      }
    } catch {}
    function measureGuideClick(event) {
      if (!event.isTrusted || event.defaultPrevented) return;
      if (event.type === 'click' && event.button !== 0) return;
      if (event.type === 'auxclick' && event.button !== 1) return;
      const link = event.target.closest?.('a[data-lnr-guide]');
      if (!link || link.hasAttribute('data-guide-preview') || window.Shopify?.designMode) return;
      if (window.Shopify?.theme?.role !== 'main') return;
      const privacy = window.Shopify?.customerPrivacy;
      try {
        if (privacy?.analyticsProcessingAllowed?.() !== true) return;
        const { productId, productHandle, guideVersion } = link.dataset;
        const documentType = link.dataset.documentType || 'guide';
        if (documentType !== 'guide' && documentType !== 'spec_sheet') return;
        if (!/^\d{1,20}$/.test(productId) || !/^[a-z0-9-]{1,200}$/.test(productHandle) || !/^[a-f0-9]{12}$/.test(guideVersion)) return;
        const now = Date.now();
        if (now - (recent.get(link) ?? -Infinity) < 800) return;
        const eventId = crypto.randomUUID();
        recent.set(link, now);
        void fetch('https://lunaria-assistant-private.onrender.com/api/storefront/guide-click', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({
            event_id: eventId,
            product_id: productId,
            product_handle: productHandle,
            guide_version: guideVersion,
            document_type: documentType
          }),
          credentials: 'omit',
          referrerPolicy: 'no-referrer',
          keepalive: true
        }).catch(() => {});
      } catch {}
    }
    document.addEventListener('click', measureGuideClick, { passive: true });
    document.addEventListener('auxclick', measureGuideClick, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lnr-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lunaria-share-button')) {
    class LunariaShareButton extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-share-label]');
        this.status = this.querySelector('[role="status"]');
        this.input = this.querySelector('input');
        this.originalLabel = this.label.textContent;
        this.abort = new AbortController();
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.share(), { signal: this.abort.signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        clearTimeout(this.resetTimer);
      }
      async share() {
        if (this.button.disabled) return;
        this.button.disabled = true;
        this.input.hidden = true;
        this.status.textContent = '';
        clearTimeout(this.resetTimer);
        this.label.textContent = this.originalLabel;
        const data = { title: this.dataset.title, url: this.dataset.url };
        try {
          if (typeof navigator.share === 'function') {
            try {
              await navigator.share(data);
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
          await navigator.clipboard.writeText(data.url);
          this.label.textContent = this.dataset.copiedLabel;
          this.status.textContent = this.dataset.copiedStatus;
          this.resetTimer = setTimeout(() => { this.label.textContent = this.originalLabel; }, 2200);
        } catch (_) {
          this.input.hidden = false;
          this.status.textContent = this.dataset.copyLabel;
          this.input.focus();
          this.input.select();
        } finally {
          this.button.disabled = false;
        }
      }
    }
    customElements.define('lunaria-share-button', LunariaShareButton);
  }
  } catch(e) { console.error(e); }
})();

})();
